module.exports = __webpack_public_path__ + "img/img_top10_trade.a823b6ee.png";